/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import React from "react";
// rs
import nomorAntrian from '../assets/img/nomor-antrian.png';
import displayAntrian from '../assets/img/display-antrian.png';
// ijv
import dashboardIJV from '../assets/img/ijv/dashboard.png';
import pengumumanIJV from '../assets/img/ijv/pengumuman.png';
import caraMendaftarIJV from '../assets/img/ijv/cara-mendaftar.png';
import faqIJV from '../assets/img/ijv/faq.png';
import contohDokumenIJV from '../assets/img/ijv/contoh-dokumen.png';
import formasi1IJV from '../assets/img/ijv/formasi.png';
import formasi2IJV from '../assets/img/ijv/formasi2.png';
// eksis
import dashboardAnalisisBerita from '../assets/img/eksis/dashboard-analisis-berita.jpeg';
import dashboardInterestChart from '../assets/img/eksis/dashboard-interest-chart.jpeg';
import monitoringUpdateList from '../assets/img/eksis/monitoring-update-list.png';
import monitoringUpdateListRiwayat from '../assets/img/eksis/monitoring-update-riwayat.png';
import monitoringUpdateDetails from '../assets/img/eksis/monitoring-update-details.png';
import monitoringUpdateDetails2 from '../assets/img/eksis/monitoring-update-details-2.png';
import monitoringUpdateTambah from '../assets/img/eksis/monitoring-update-tambah.png';
import monitoringUpdateTambah2 from '../assets/img/eksis/monitoring-update-tambah-2.png';
// cpns backoffice
import rekamKebugaranList from '../assets/img/cpns/backoffice/Rekam-kebugaran-list.png';
import rekapPetugas from '../assets/img/cpns/backoffice/Rekap-petugas.png';
import riwayatKebugaran from '../assets/img/cpns/backoffice/Riwayat-kebugaran.png';
import riwayatKesehatan from '../assets/img/cpns/backoffice/Riwayat-kesehatan.png';
import uploadHasilLab from '../assets/img/cpns/backoffice/Upload-hasil-lab.png';
import dialogRekamAntrian from '../assets/img/cpns/backoffice/dialog-rekam-antrian.png';
import dialogSave from '../assets/img/cpns/backoffice/dialog-save.png';
import dialogSimpanRekamAntrian from '../assets/img/cpns/backoffice/dialog-simpan-rekam-antrian.png';
import editLokasiTkk from '../assets/img/cpns/backoffice/edit-lokasi-tkk.png';
import kunciDataVerifikasiKebugaran from '../assets/img/cpns/backoffice/kunci-data-verifikasi-kebugaran.png';
import lokasiTkk from '../assets/img/cpns/backoffice/lokasi-tkk.png';
import nilaiAkhir from '../assets/img/cpns/backoffice/nilai-akhir.png';
import paramedisDetailsDokter from '../assets/img/cpns/backoffice/paramedis-details-dokter.png';
import paramedisDetailsEdit from '../assets/img/cpns/backoffice/paramedis-details-edit.png';
import paramedisDetails from '../assets/img/cpns/backoffice/paramedis-details.png';
import paramedisEditDokter from '../assets/img/cpns/backoffice/paramedis-edit-dokter.png';
import paramedisListDokter from '../assets/img/cpns/backoffice/paramedis-list-dokter.png';
import paramedisList from '../assets/img/cpns/backoffice/paramedis-list.png';
import pdfViewerVerifikasiKebugaran from '../assets/img/cpns/backoffice/pdf-viewer-verifikasi-kebugaran.png';
import printBukti from '../assets/img/cpns/backoffice/print-bukti.png';
import rekamAntrian from '../assets/img/cpns/backoffice/rekam-antrian.png';
import riwayatKelompok from '../assets/img/cpns/backoffice/riwayat-kelompok.png';
import uploadHasilKebugaran from '../assets/img/cpns/backoffice/upload-hasil-kebugaran.png';
import verifikasiKebugaranDetails from '../assets/img/cpns/backoffice/verifikasi-kebugaran-details.png';
import verifikasiKebugaranEdit from '../assets/img/cpns/backoffice/verifikasi-kebugaran-edit.png';
import verifikasiKebugaran from '../assets/img/cpns/backoffice/verifikasi-kebugaran.png';
// cpns frontoffice
import dialogVerifikasiData from '../assets/img/cpns/frontoffice/dialog-verifikasi-data.png';
import kunciData from '../assets/img/cpns/frontoffice/kunci-data.png';
import kunciData2 from '../assets/img/cpns/frontoffice/kunci-data2.png';
import pemberkasanDataDiri from '../assets/img/cpns/frontoffice/pemberkasan-data-diri.png';
import unggahDokumen from '../assets/img/cpns/frontoffice/unggah-dokumen.png';
import verifikasiDanInputData from '../assets/img/cpns/frontoffice/verifikasi-dan-input-data.png';
import verifikasiDanInputData2 from '../assets/img/cpns/frontoffice/verifikasi-dan-input-data2.png';
// stan alihprogram
import aktivasiAkunStan from '../assets/img/stan/alih-program/aktivasi-akun.png';
import bannerPendaftaranStan from '../assets/img/stan/alih-program/banner-pendaftaran.png';
import berandaStan from '../assets/img/stan/alih-program/beranda.png';
import biodataStan from '../assets/img/stan/alih-program/biodata.png';
import biodata2Stan from '../assets/img/stan/alih-program/biodata2.png';
import biodata3Stan from '../assets/img/stan/alih-program/biodata3.png';
import cetakBpsStan from '../assets/img/stan/alih-program/cetak-bps.png';
import dialogKunciDataStan from '../assets/img/stan/alih-program/dialog-kunci-data.png';
import dialogKunciData2Stan from '../assets/img/stan/alih-program/dialog-kunci-data2.png';
import formIps2Stan from '../assets/img/stan/alih-program/form-ips-2.png';
import formIpsStan from '../assets/img/stan/alih-program/form-ips.png';
import kunciDataStan from '../assets/img/stan/alih-program/kunci-data.png';
import kunciData2Stan from '../assets/img/stan/alih-program/kunci-data2.png';
import loginStan from '../assets/img/stan/alih-program/login.png';
import uploadFileStan from '../assets/img/stan/alih-program/upload-file.png';
// perpustakaan
import antreanPeminjaman from '../assets/img/perpus/antrean-peminjaman.png';
import bayarDenda from '../assets/img/perpus/bayar-denda.png';
import collapseListPenagihan from '../assets/img/perpus/collapse-list-penagihan.png';
import editPenagihan from '../assets/img/perpus/edit-penagihan.png';
import lihatPembayaranForm from '../assets/img/perpus/lihat-pembayaran-form.png';
import lihatPembayaranList from '../assets/img/perpus/lihat-pembayaran-list.png';
import peminjamanRolePemustaka from '../assets/img/perpus/peminjaman-role-pemustaka.png';
import peminjamanUlasanEdit from '../assets/img/perpus/peminjaman-ulasan-edit.png';
import peminjamanUlasan from '../assets/img/perpus/peminjaman-ulasan.png';
import peminjaman from '../assets/img/perpus/peminjaman.png';
import penagihan from '../assets/img/perpus/penagihan.png';
import tambahPeminjamanPengelola2 from '../assets/img/perpus/tambah-peminjaman-pengelola-2.png';
import tambahPeminjamanPengelola from '../assets/img/perpus/tambah-peminjaman-pengelola.png';
import ubahPenagihan from '../assets/img/perpus/ubah-penagihan.png';
import dialogScanner from '../assets/img/perpus/dialog-scanner.png';
import dialogScanner2 from '../assets/img/perpus/dialog-scanner2.png';
// pendidikan
import seleksiUptbList from '../assets/img/pendidikan/seleksi-uptb-list.png';
import detailsSeleksiKonsep from '../assets/img/pendidikan/details-seleksi-konsep.png';
import detailsSeleksiNadine from '../assets/img/pendidikan/details-seleksi-nadine.png';
import dialogAmbilNadine from '../assets/img/pendidikan/dialog-ambil-nadine.png';
import formDokumenNadine from '../assets/img/pendidikan/form-dokumen-nadine.png';
import formSeleksiEdit from '../assets/img/pendidikan/form-seleksi-edit.png';
import formSeleksi from '../assets/img/pendidikan/form-seleksi.png';
import hapusData from '../assets/img/pendidikan/hapus-data.png';
import kirimKonsep from '../assets/img/pendidikan/kirim-konsep.png';
// saas
import editFotoSaas from '../assets/img/saas/edit-foto.png';
import manajemenMenuListSaas from '../assets/img/saas/manajemen-menu-list.png';
import manajemenTenantFormSaas from '../assets/img/saas/manajemen-tenant-form.png';
import manajemenTenantListSaas from '../assets/img/saas/manajemen-tenant-list.png';
// hackathon-imphnen
import confirmPesanan from '../assets/img/hackathon-imphnen/confirm-pesanan.png';
import denahTenant from '../assets/img/hackathon-imphnen/denah-tenant.png';
import menuAwal from '../assets/img/hackathon-imphnen/menu-awal.png';
import orderMenu from '../assets/img/hackathon-imphnen/order-menu.png';
import riwayatPesanan from '../assets/img/hackathon-imphnen/riwayat-pesanan.png';
import riwayatPesanan2 from '../assets/img/hackathon-imphnen/riwayat-pesanan2.png';
import sandboxPembayaran from '../assets/img/hackathon-imphnen/sandbox-pembayaran.png';
import successfulPayment from '../assets/img/hackathon-imphnen/successful-payment.png';
import sertifikatHackhathon from '../assets/img/hackathon-imphnen/sertifikat.png';
// lps
import formLps from '../assets/img/lps/form.png';
import form1Lps from '../assets/img/lps/form1.png';
import kunciDataLps from '../assets/img/lps/kunci-data.png';
import loginLps from '../assets/img/lps/loginpng.png';
// finflow
import finflow1 from '../assets/img/finflow/IMG_6930.PNG';
import finflow2 from '../assets/img/finflow/IMG_6931.PNG';
import finflow3 from '../assets/img/finflow/IMG_6932.PNG';
import finflow4 from '../assets/img/finflow/IMG_6933.PNG';
import finflow5 from '../assets/img/finflow/IMG_6934.PNG';
import finflow6 from '../assets/img/finflow/IMG_6935.PNG';
import finflow7 from '../assets/img/finflow/IMG_6936.PNG';
import finflow8 from '../assets/img/finflow/IMG_6937.PNG';
import finflow9 from '../assets/img/finflow/IMG_6938.PNG';
import finflow10 from '../assets/img/finflow/IMG_6939.PNG';
import finflow11 from '../assets/img/finflow/IMG_6940.PNG';
import finflow12 from '../assets/img/finflow/IMG_6941.PNG';
import finflow13 from '../assets/img/finflow/IMG_6942.PNG';
import finflow14 from '../assets/img/finflow/IMG_6943.PNG';
import finflow15 from '../assets/img/finflow/IMG_6944.PNG';
import finflow16 from '../assets/img/finflow/IMG_6945.PNG';
import finflow17 from '../assets/img/finflow/IMG_6946.PNG';

// import comingSoon from '../assets/img/coming-soon.jpg'

import 'photoswipe/dist/photoswipe.css'
import { Gallery, Item } from 'react-photoswipe-gallery'


function Portofolio() {
  const smallItemStyles = {
    cursor: 'pointer',
    objectFit: 'cover',
    width: '100%',
    maxHeight: '100%',
  };

  const uiElements = [
    {
      name: 'bulletsIndicator',
      order: 9,
      isButton: false,
      appendTo: 'wrapper',
      onInit: (el, pswpInstance) => {
        let prevIndex = -1;
        const thumbnails = [];

        el.style.position = 'absolute';
        el.style.bottom = '50px';
        el.style.left = '10px';
        el.style.right = '0';
        el.style.display = 'grid';
        el.style.gridGap = '10px';
        el.style.gridTemplateColumns = 'repeat(auto-fit, 40px)';
        el.style.gridTemplateRows = 'repeat(auto-fit, 40px)';
        el.style.justifyContent = 'center';

        const dataSource = pswpInstance.options.dataSource;

        for (let i = 0; i < dataSource.length; i++) {
          const slideData = dataSource[i];

          const thumbnail = document.createElement('div');
          thumbnail.style.transition = 'transform 0.15s ease-in';
          thumbnail.style.opacity = '0.6';
          thumbnail.style.cursor = 'pointer';
          thumbnail.onclick = (e) => {
            const target = e.target;
            const thumbnailEl =
              target.tagName === 'IMG'
                ? target.parentElement
                : target;
            if (thumbnailEl) {
              pswpInstance.goTo(thumbnails.indexOf(thumbnailEl));
            }
          };

          const thumbnailImage = document.createElement('img');
          thumbnailImage.setAttribute('src', slideData.msrc || '');
          thumbnailImage.style.width = '100%';
          thumbnailImage.style.height = '100%';
          thumbnailImage.style.objectFit = 'cover';

          thumbnail.appendChild(thumbnailImage);

          el.appendChild(thumbnail);

          thumbnails.push(thumbnail);
        }

        pswpInstance.on('change', () => {
          if (prevIndex >= 0) {
            const prevThumbnail = thumbnails[prevIndex];
            prevThumbnail.style.opacity = '0.6';
            prevThumbnail.style.cursor = 'pointer';
            prevThumbnail.style.transform = 'scale(1)';
          }

          const currentThumbnail = thumbnails[pswpInstance.currIndex];
          currentThumbnail.style.opacity = '1';
          currentThumbnail.style.cursor = 'unset';
          currentThumbnail.style.transform = 'scale(1.2)';

          prevIndex = pswpInstance.currIndex;
        });
      },
    },
  ];

  return (
    <div className="p-4 md:p-10 md:h-full">
      <div className="relative scrollbar-hide lg:overflow-y-auto lg:max-h-[700px]">
        <h1 className="text-center font-bold text-2xl pb-3 text-gradient-primary uppercase">
          Galeri Portofolio
        </h1>
        <div className="w-24 h-1 bg-gradient-accent rounded-full mx-auto mb-8"></div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-4 scrollbar-hide h-auto md:h-[35rem]">
          <Gallery uiElements={uiElements} withCaption>
            <div className="max-w-ws h-full rounded-lg border-b shadow-md bg-gradient-primary border-blue-900 transition-all duration-300 hover:scale-105 hover:shadow-xl cursor-pointer">
              <Item
                original={nomorAntrian}
                thumbnail={nomorAntrian}
                width="1280"
                height="720"
                caption="Tampilan Nomor Antrian"
              >
                {({ ref, open }) => (
                  <img className="rounded-t-lg h-48 object-cover w-full"
                    style={{ cursor: 'pointer' }}
                    src={nomorAntrian}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={displayAntrian}
                thumbnail={displayAntrian}
                width="1280"
                height="720"
                caption="Tampilan Display Antrian Ruang Tunggu Rumah Sakit"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>
              <div className="p-5">
                <h5 className="mb-2 text-sm font-semibold tracking-tigh text-center text-white">
                  RSUD. DR. M. H. Rabain
                </h5>
                <div className="flex gap-2 mt-3 justify-start">
                  <span className="px-2 py-1 text-xs font-medium text-white bg-orange-600 rounded-full">Laravel</span>
                  <span className="px-2 py-1 text-xs font-medium text-white bg-cyan-500 rounded-full">Tailwind</span>
                </div>
              </div>

            </div>

          </Gallery>

          <Gallery uiElements={uiElements} withCaption>
            <div className="max-w-ws h-full rounded-lg border-b shadow-md bg-gradient-primary border-blue-900 transition-all duration-300 hover:scale-105 hover:shadow-xl cursor-pointer">
              <Item
                original={dashboardAnalisisBerita}
                thumbnail={dashboardAnalisisBerita}
                width="1280"
                height="720"
                caption="Tampilan Dashboard Eksis Tab Analisis Berita"
              >
                {({ ref, open }) => (
                  <img className="rounded-t-lg h-48 object-cover w-full"
                    style={{ cursor: 'pointer' }}
                    src={dashboardAnalisisBerita}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={dashboardInterestChart}
                thumbnail={dashboardInterestChart}
                width="1280"
                height="720"
                caption="Tampilan Dashboard Eksis Tab Power-Interest Chart"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={monitoringUpdateList}
                thumbnail={monitoringUpdateList}
                width="1280"
                height="720"
                caption="Tampilan Module List Monitoring Update"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={monitoringUpdateListRiwayat}
                thumbnail={monitoringUpdateListRiwayat}
                width="1280"
                height="720"
                caption="Tampilan Module List Monitoring Update Riwayat"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={monitoringUpdateDetails}
                thumbnail={monitoringUpdateDetails}
                width="1280"
                height="720"
                caption="Tampilan Module Details Monitoring Update"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={monitoringUpdateDetails2}
                thumbnail={monitoringUpdateDetails2}
                width="1280"
                height="720"
                caption="Tampilan Module Details Monitoring Update Riwayat"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={monitoringUpdateTambah}
                thumbnail={monitoringUpdateTambah}
                width="1280"
                height="720"
                caption="Tampilan Module Monitoring Update Tambah Data"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={monitoringUpdateTambah2}
                thumbnail={monitoringUpdateTambah2}
                width="1280"
                height="720"
                caption="Tampilan Module List Monitoring Update Tambah Data (2)"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>
              <div className="p-5">
                <h5 className="mb-2 text-sm font-semibold tracking-tigh text-center text-white">
                  Ekosistem Informasi Kehumasan Kementerian Keuangan
                </h5>
                <div className="flex gap-2 mt-3 justify-start">
                  <span className="px-2 py-1 text-xs font-medium text-white bg-red-600 rounded-full">Angular</span>
                  <span className="px-2 py-1 text-xs font-medium text-white bg-cyan-500 rounded-full">Tailwind</span>
                </div>
              </div>
            </div>
          </Gallery>

          <Gallery uiElements={uiElements} withCaption>
            <div className="max-w-ws h-full rounded-lg border-b shadow-md bg-gradient-primary border-blue-900 transition-all duration-300 hover:scale-105 hover:shadow-xl cursor-pointer">
              <Item
                original={dashboardIJV}
                thumbnail={dashboardIJV}
                width="1280"
                height="720"
                caption="Tampilan Dashboard IJV untuk informasi jumlah pegawai yang sudah terdaftar"
              >
                {({ ref, open }) => (
                  <img className="rounded-t-lg h-48 object-cover w-full"
                    style={{ cursor: 'pointer' }}
                    src={dashboardIJV}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={pengumumanIJV}
                thumbnail={pengumumanIJV}
                width="1280"
                height="720"
                caption="Tampilan Antrian Ruang Tunggu Rumah Sakit"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={caraMendaftarIJV}
                thumbnail={caraMendaftarIJV}
                width="1280"
                height="720"
                caption="Tampilan Cara Mendaftar"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={faqIJV}
                thumbnail={faqIJV}
                width="1280"
                height="720"
                caption="Tampilan FAQ"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={contohDokumenIJV}
                thumbnail={contohDokumenIJV}
                width="1280"
                height="720"
                caption="Tampilan Contoh Dokumen yang bisa user download"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={formasi1IJV}
                thumbnail={formasi1IJV}
                width="1280"
                height="720"
                caption="Tampilan Formasi yang tersedia"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={formasi2IJV}
                thumbnail={formasi2IJV}
                width="1280"
                height="720"
                caption="Tampilan Formasi yang tersedia"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>
              <div className="p-5">
                <h5 className="mb-2 text-sm font-semibold tracking-tigh text-center text-white">
                  Internal Job Vacancy (IJV)
                </h5>
                <div className="flex gap-2 mt-3 justify-start">
                  <span className="px-2 py-1 text-xs font-medium text-white bg-red-600 rounded-full">Angular</span>
                  <span className="px-2 py-1 text-xs font-medium text-white bg-cyan-500 rounded-full">Tailwind</span>
                </div>
              </div>
            </div>
          </Gallery>

          <Gallery uiElements={uiElements} withCaption>
            <div className="max-w-ws h-full rounded-lg border-b shadow-md bg-gradient-primary border-blue-900 transition-all duration-300 hover:scale-105 hover:shadow-xl cursor-pointer">
              <Item
                original={paramedisList}
                thumbnail={paramedisList}
                width="1280"
                height="720"
                caption="Tampilan Paramedis List"
              >
                {({ ref, open }) => (
                  <img className="rounded-t-lg h-48 object-cover w-full"
                    style={{ cursor: 'pointer' }}
                    src={paramedisList}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={paramedisDetails}
                thumbnail={paramedisDetails}
                width="1280"
                height="720"
                caption="Tampilan Paramedis Details"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={paramedisDetailsDokter}
                thumbnail={paramedisDetailsDokter}
                width="1280"
                height="720"
                caption="Tampilan Paramedis Details"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={paramedisEditDokter}
                thumbnail={paramedisEditDokter}
                width="1280"
                height="720"
                caption="Tampilan Paramedis Edit Dokter"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={dialogSave}
                thumbnail={dialogSave}
                width="1280"
                height="720"
                caption="Tampilan Dialog Simpan"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={rekamAntrian}
                thumbnail={rekamAntrian}
                width="1280"
                height="720"
                caption="Tampilan Rekam Antrian"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={dialogRekamAntrian}
                thumbnail={dialogRekamAntrian}
                width="1280"
                height="720"
                caption="Tampilan Dialog Rekam Antrian"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={dialogSimpanRekamAntrian}
                thumbnail={dialogSimpanRekamAntrian}
                width="1280"
                height="720"
                caption="Tampilan Dialog Simpan Rekam Antrian"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={verifikasiKebugaran}
                thumbnail={verifikasiKebugaran}
                width="1280"
                height="720"
                caption="Tampilan Verifikasi Kebugaran"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={verifikasiKebugaranDetails}
                thumbnail={verifikasiKebugaranDetails}
                width="1280"
                height="720"
                caption="Tampilan Verifikasi Kebugaran Details"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={verifikasiKebugaranEdit}
                thumbnail={verifikasiKebugaranEdit}
                width="1280"
                height="720"
                caption="Tampilan Verifikasi Kebugaran Edit"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={pdfViewerVerifikasiKebugaran}
                thumbnail={pdfViewerVerifikasiKebugaran}
                width="1280"
                height="720"
                caption="Tampilan PDF Viewer Verifikasi Kebugaran"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={kunciDataVerifikasiKebugaran}
                thumbnail={kunciDataVerifikasiKebugaran}
                width="1280"
                height="720"
                caption="Tampilan Kunci Data Verifikasi Kebugaran"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={printBukti}
                thumbnail={printBukti}
                width="1280"
                height="720"
                caption="Tampilan Print Bukti"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={rekamKebugaranList}
                thumbnail={rekamKebugaranList}
                width="1280"
                height="720"
                caption="Tampilan Rekam Kebugaran List"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={uploadHasilKebugaran}
                thumbnail={uploadHasilKebugaran}
                width="1280"
                height="720"
                caption="Tampilan Upload Hasil Kebugaran"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={riwayatKebugaran}
                thumbnail={riwayatKebugaran}
                width="1280"
                height="720"
                caption="Tampilan Riwayat Kebugaran"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={riwayatKesehatan}
                thumbnail={riwayatKesehatan}
                width="1280"
                height="720"
                caption="Tampilan Riwayat Kesehatan"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={uploadHasilLab}
                thumbnail={uploadHasilLab}
                width="1280"
                height="720"
                caption="Tampilan Upload Hasil Lab"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={riwayatKelompok}
                thumbnail={riwayatKelompok}
                width="1280"
                height="720"
                caption="Tampilan Riwayat Kelompok"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={lokasiTkk}
                thumbnail={lokasiTkk}
                width="1280"
                height="720"
                caption="Tampilan Lokasi TKK"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={editLokasiTkk}
                thumbnail={editLokasiTkk}
                width="1280"
                height="720"
                caption="Tampilan Edit Lokasi TKK"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={paramedisListDokter}
                thumbnail={paramedisListDokter}
                width="1280"
                height="720"
                caption="Tampilan Paramedis List Dokter"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={paramedisDetailsEdit}
                thumbnail={paramedisDetailsEdit}
                width="1280"
                height="720"
                caption="Tampilan Paramedis Details Edit"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={rekapPetugas}
                thumbnail={rekapPetugas}
                width="1280"
                height="720"
                caption="Tampilan Rekap Petugas"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={nilaiAkhir}
                thumbnail={nilaiAkhir}
                width="1280"
                height="720"
                caption="Tampilan Nilai Akhir"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>


              <div className="p-5">
                <h5 className="mb-2 text-sm font-semibold tracking-tigh text-center text-white">
                  Rekrutmen CASN 2024 - Back Office
                </h5>
                <div className="flex gap-2 mt-3 justify-start">
                  <span className="px-2 py-1 text-xs font-medium text-white bg-red-600 rounded-full">Angular</span>
                  <span className="px-2 py-1 text-xs font-medium text-white bg-cyan-500 rounded-full">Tailwind</span>
                </div>
              </div>

            </div>

          </Gallery>

          <Gallery uiElements={uiElements} withCaption>
            <div className="max-w-ws h-full rounded-lg border-b shadow-md bg-gradient-primary border-blue-900 transition-all duration-300 hover:scale-105 hover:shadow-xl cursor-pointer">
              <Item
                original={verifikasiDanInputData}
                thumbnail={verifikasiDanInputData}
                width="1280"
                height="720"
                caption="Tampilan Verifikasi dan Input Data"
              >
                {({ ref, open }) => (
                  <img className="rounded-t-lg h-48 object-cover w-full"
                    style={{ cursor: 'pointer' }}
                    src={verifikasiDanInputData}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={verifikasiDanInputData2}
                thumbnail={verifikasiDanInputData2}
                width="1280"
                height="720"
                caption="Tampilan Verifikasi dan Input Data (2)"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={pemberkasanDataDiri}
                thumbnail={pemberkasanDataDiri}
                width="1280"
                height="720"
                caption="Tampilan Pemberkasan Data Diri"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={unggahDokumen}
                thumbnail={unggahDokumen}
                width="1280"
                height="720"
                caption="Tampilan Unggah Dokumen"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={dialogVerifikasiData}
                thumbnail={dialogVerifikasiData}
                width="1280"
                height="720"
                caption="Tampilan Dialog Verifikasi Data"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={kunciData}
                thumbnail={kunciData}
                width="1280"
                height="720"
                caption="Tampilan Kunci Data"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={kunciData2}
                thumbnail={kunciData2}
                width="1280"
                height="720"
                caption="Tampilan Kunci Data (2)"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <div className="p-5">
                <h5 className="mb-2 text-sm font-semibold tracking-tigh text-center text-white">
                  Rekrutmen CASN 2024 - Front Office
                </h5>
                <div className="flex gap-2 mt-3 justify-start">
                  <span className="px-2 py-1 text-xs font-medium text-white bg-red-600 rounded-full">Angular</span>
                  <span className="px-2 py-1 text-xs font-medium text-white bg-cyan-500 rounded-full">Bootstrap</span>
                </div>
              </div>

            </div>

          </Gallery>

          <Gallery uiElements={uiElements} withCaption>
            <div className="max-w-ws h-full rounded-lg border-b shadow-md bg-gradient-primary border-blue-900 transition-all duration-300 hover:scale-105 hover:shadow-xl cursor-pointer">
              <Item
                original={loginLps}
                thumbnail={loginLps}
                width="1280"
                height="720"
                caption="Tampilan Login"
              >
                {({ ref, open }) => (
                  <img className="rounded-t-lg h-48 object-cover w-full"
                    style={{ cursor: 'pointer' }}
                    src={loginLps}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={formLps}
                thumbnail={formLps}
                width="1280"
                height="720"
                caption="Tampilan Form"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={form1Lps}
                thumbnail={form1Lps}
                width="1280"
                height="720"
                caption="Tampilan Form Lanjutan"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={kunciDataLps}
                thumbnail={kunciDataLps}
                width="1280"
                height="720"
                caption="Tampilan Kunci Data"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <div className="p-5">
                <h5 className="mb-2 text-sm font-semibold tracking-tigh text-center text-white">
                  Seleksi Dewan Komisioner LPS 2024
                </h5>
                <div className="flex gap-2 mt-3 justify-start">
                  <span className="px-2 py-1 text-xs font-medium text-white bg-red-600 rounded-full">Angular</span>
                  <span className="px-2 py-1 text-xs font-medium text-white bg-cyan-500 rounded-full">Bootstrap</span>
                </div>
              </div>

            </div>
          </Gallery>

          <Gallery uiElements={uiElements} withCaption>
            <div className="max-w-ws h-full rounded-lg border-b shadow-md bg-gradient-primary border-blue-900 transition-all duration-300 hover:scale-105 hover:shadow-xl cursor-pointer">
              <Item
                original={loginStan}
                thumbnail={loginStan}
                width="1280"
                height="720"
                caption="Tampilan Login STAN Alih Program"
              >
                {({ ref, open }) => (
                  <img className="rounded-t-lg h-48 object-cover w-full"
                    style={{ cursor: 'pointer' }}
                    src={loginStan}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={aktivasiAkunStan}
                thumbnail={aktivasiAkunStan}
                width="1280"
                height="720"
                caption="Tampilan Aktivasi Akun"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={berandaStan}
                thumbnail={berandaStan}
                width="1280"
                height="720"
                caption="Tampilan Beranda STAN"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={bannerPendaftaranStan}
                thumbnail={bannerPendaftaranStan}
                width="1280"
                height="720"
                caption="Tampilan Banner Pendaftaran"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={biodataStan}
                thumbnail={biodataStan}
                width="1280"
                height="720"
                caption="Tampilan Biodata (1)"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={biodata2Stan}
                thumbnail={biodata2Stan}
                width="1280"
                height="720"
                caption="Tampilan Biodata (2)"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={biodata3Stan}
                thumbnail={biodata3Stan}
                width="1280"
                height="720"
                caption="Tampilan Biodata (3)"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={formIpsStan}
                thumbnail={formIpsStan}
                width="1280"
                height="720"
                caption="Tampilan Form IPS"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={formIps2Stan}
                thumbnail={formIps2Stan}
                width="1280"
                height="720"
                caption="Tampilan Form IPS (2)"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={uploadFileStan}
                thumbnail={uploadFileStan}
                width="1280"
                height="720"
                caption="Tampilan Upload File"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={kunciDataStan}
                thumbnail={kunciDataStan}
                width="1280"
                height="720"
                caption="Tampilan Kunci Data"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={dialogKunciDataStan}
                thumbnail={dialogKunciDataStan}
                width="1280"
                height="720"
                caption="Tampilan Dialog Kunci Data"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={kunciData2Stan}
                thumbnail={kunciData2Stan}
                width="1280"
                height="720"
                caption="Tampilan Kunci Data (2)"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={dialogKunciData2Stan}
                thumbnail={dialogKunciData2Stan}
                width="1280"
                height="720"
                caption="Tampilan Dialog Kunci Data (2)"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={cetakBpsStan}
                thumbnail={cetakBpsStan}
                width="1280"
                height="720"
                caption="Tampilan Cetak BPS"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <div className="p-5">
                <h5 className="mb-2 text-sm font-semibold tracking-tigh text-center text-white">
                  Rekrutmen STAN
                </h5>
                <div className="flex gap-2 mt-3 justify-start">
                  <span className="px-2 py-1 text-xs font-medium text-white bg-red-600 rounded-full">Angular</span>
                  <span className="px-2 py-1 text-xs font-medium text-white bg-cyan-500 rounded-full">Bootstrap</span>
                </div>
              </div>

            </div>
          </Gallery>

          <Gallery uiElements={uiElements} withCaption>
            <div className="max-w-ws h-full rounded-lg border-b shadow-md bg-gradient-primary border-blue-900 transition-all duration-300 hover:scale-105 hover:shadow-xl cursor-pointer">
              <Item
                original={manajemenMenuListSaas}
                thumbnail={manajemenMenuListSaas}
                width="1280"
                height="720"
                caption="Tampilan Manajemen Menu List"
              >
                {({ ref, open }) => (
                  <img className="rounded-t-lg h-48 object-cover w-full"
                    style={{ cursor: 'pointer' }}
                    src={manajemenMenuListSaas}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={manajemenTenantListSaas}
                thumbnail={manajemenTenantListSaas}
                width="1280"
                height="720"
                caption="Tampilan Manajemen Tenant List"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={manajemenTenantFormSaas}
                thumbnail={manajemenTenantFormSaas}
                width="1280"
                height="720"
                caption="Tampilan Manajemen Tenant Form"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={editFotoSaas}
                thumbnail={editFotoSaas}
                width="1280"
                height="720"
                caption="Tampilan Edit Foto"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <div className="p-5">
                <h5 className="mb-2 text-sm font-semibold tracking-tigh text-center text-[#F3F3F3]">
                  Manajemen SaaS
                </h5>
                <div className="flex gap-2 mt-3 justify-start">
                  <span className="px-2 py-1 text-xs font-medium text-white bg-red-600 rounded-full">Angular</span>
                  <span className="px-2 py-1 text-xs font-medium text-white bg-cyan-500 rounded-full">Tailwind</span>
                </div>
              </div>
            </div>
          </Gallery>

          <Gallery uiElements={uiElements} withCaption>
            <div className="max-w-ws h-full rounded-lg border-b shadow-md bg-gradient-primary border-blue-900 transition-all duration-300 hover:scale-105 hover:shadow-xl cursor-pointer">
              <Item
                original={peminjaman}
                thumbnail={peminjaman}
                width="1280"
                height="720"
                caption="Tampilan Peminjaman"
              >
                {({ ref, open }) => (
                  <img className="rounded-t-lg h-48 object-cover w-full"
                    style={{ cursor: 'pointer' }}
                    src={peminjaman}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={peminjamanRolePemustaka}
                thumbnail={peminjamanRolePemustaka}
                width="1280"
                height="720"
                caption="Tampilan Peminjaman Role Pemustaka"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={antreanPeminjaman}
                thumbnail={antreanPeminjaman}
                width="1280"
                height="720"
                caption="Tampilan Antrean Peminjaman"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={lihatPembayaranList}
                thumbnail={lihatPembayaranList}
                width="1280"
                height="720"
                caption="Tampilan Lihat Pembayaran List"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={lihatPembayaranForm}
                thumbnail={lihatPembayaranForm}
                width="1280"
                height="720"
                caption="Tampilan Lihat Pembayaran Form"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={collapseListPenagihan}
                thumbnail={collapseListPenagihan}
                width="1280"
                height="720"
                caption="Tampilan Collapse List Penagihan"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={penagihan}
                thumbnail={penagihan}
                width="1280"
                height="720"
                caption="Tampilan Penagihan"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={editPenagihan}
                thumbnail={editPenagihan}
                width="1280"
                height="720"
                caption="Tampilan Edit Penagihan"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={ubahPenagihan}
                thumbnail={ubahPenagihan}
                width="1280"
                height="720"
                caption="Tampilan Ubah Penagihan"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={bayarDenda}
                thumbnail={bayarDenda}
                width="1280"
                height="720"
                caption="Tampilan Bayar Denda"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={peminjamanUlasanEdit}
                thumbnail={peminjamanUlasanEdit}
                width="1280"
                height="720"
                caption="Tampilan Peminjaman Ulasan Edit"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={peminjamanUlasan}
                thumbnail={peminjamanUlasan}
                width="1280"
                height="720"
                caption="Tampilan Peminjaman Ulasan"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={tambahPeminjamanPengelola}
                thumbnail={tambahPeminjamanPengelola}
                width="1280"
                height="720"
                caption="Tampilan Tambah Peminjaman Pengelola"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={tambahPeminjamanPengelola2}
                thumbnail={tambahPeminjamanPengelola2}
                width="1280"
                height="720"
                caption="Tampilan Tambah Peminjaman Pengelola 2"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={dialogScanner}
                thumbnail={dialogScanner}
                width="1280"
                height="720"
                caption="Tampilan Dialog Scanner Buku"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={dialogScanner2}
                thumbnail={dialogScanner2}
                width="1280"
                height="720"
                caption="Tampilan Dialog Setelah Scanner Buku"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>
              <div className="p-5">
                <h5 className="mb-2 text-sm font-semibold tracking-tigh text-center text-[#F3F3F3]">
                  Perpustakaan
                </h5>
                <div className="flex gap-2 mt-3 justify-start">
                  <span className="px-2 py-1 text-xs font-medium text-white bg-red-600 rounded-full">Angular</span>
                  <span className="px-2 py-1 text-xs font-medium text-white bg-cyan-500 rounded-full">Tailwind</span>
                </div>
              </div>
            </div>
          </Gallery>

          <Gallery uiElements={uiElements} withCaption>
            <div className="max-w-ws h-full rounded-lg border-b shadow-md bg-gradient-primary border-blue-900 transition-all duration-300 hover:scale-105 hover:shadow-xl cursor-pointer">
              <Item
                original={seleksiUptbList}
                thumbnail={seleksiUptbList}
                width="1280"
                height="720"
                caption="Tampilan Seleksi UPTB List"
              >
                {({ ref, open }) => (
                  <img className="rounded-t-lg h-48 object-cover w-full"
                    style={{ cursor: 'pointer' }}
                    src={seleksiUptbList}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={detailsSeleksiKonsep}
                thumbnail={detailsSeleksiKonsep}
                width="1280"
                height="720"
                caption="Tampilan Details Seleksi Konsep"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={detailsSeleksiNadine}
                thumbnail={detailsSeleksiNadine}
                width="1280"
                height="720"
                caption="Tampilan Details Seleksi Nadine"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={dialogAmbilNadine}
                thumbnail={dialogAmbilNadine}
                width="1280"
                height="720"
                caption="Tampilan Dialog Ambil Nadine"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={formDokumenNadine}
                thumbnail={formDokumenNadine}
                width="1280"
                height="720"
                caption="Tampilan Form Dokumen Nadine"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={formSeleksi}
                thumbnail={formSeleksi}
                width="1280"
                height="720"
                caption="Tampilan Form Seleksi"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={formSeleksiEdit}
                thumbnail={formSeleksiEdit}
                width="1280"
                height="720"
                caption="Tampilan Form Seleksi Edit"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={hapusData}
                thumbnail={hapusData}
                width="1280"
                height="720"
                caption="Tampilan Hapus Data"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={kirimKonsep}
                thumbnail={kirimKonsep}
                width="1280"
                height="720"
                caption="Tampilan Kirim Konsep"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>
              <div className="p-5">
                <h5 className="mb-2 text-sm font-semibold tracking-tigh text-center text-[#F3F3F3]">
                  Pendidikan
                </h5>
                <div className="flex gap-2 mt-3 justify-start">
                  <span className="px-2 py-1 text-xs font-medium text-white bg-red-600 rounded-full">Angular</span>
                  <span className="px-2 py-1 text-xs font-medium text-white bg-cyan-500 rounded-full">Tailwind</span>
                </div>
              </div>
            </div>
          </Gallery>

          <Gallery uiElements={uiElements} withCaption>
            <div className="max-w-ws h-full rounded-lg border-b shadow-md bg-gradient-primary border-blue-900 transition-all duration-300 hover:scale-105 hover:shadow-xl cursor-pointer">
              <Item
                original={menuAwal}
                thumbnail={menuAwal}
                width="1280"
                height="720"
                caption="Tampilan Menu Awal"
              >
                {({ ref, open }) => (
                  <img className="rounded-t-lg h-48 object-cover w-full"
                    style={{ cursor: 'pointer' }}
                    src={menuAwal}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={orderMenu}
                thumbnail={orderMenu}
                width="1280"
                height="720"
                caption="Tampilan Order Menu"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={confirmPesanan}
                thumbnail={confirmPesanan}
                width="1280"
                height="720"
                caption="Tampilan Konfirmasi Pesanan"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={sandboxPembayaran}
                thumbnail={sandboxPembayaran}
                width="1280"
                height="720"
                caption="Tampilan Sandbox Pembayaran"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={successfulPayment}
                thumbnail={successfulPayment}
                width="1280"
                height="720"
                caption="Tampilan Pembayaran Berhasil"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={riwayatPesanan}
                thumbnail={riwayatPesanan}
                width="1280"
                height="720"
                caption="Tampilan Riwayat Pesanan"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={riwayatPesanan2}
                thumbnail={riwayatPesanan2}
                width="1280"
                height="720"
                caption="Tampilan Detail Riwayat Pesanan"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={denahTenant}
                thumbnail={denahTenant}
                width="1280"
                height="720"
                caption="Tampilan Denah Tenant"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item
                original={sertifikatHackhathon}
                thumbnail={sertifikatHackhathon}
                width="1280"
                height="720"
                caption="Sertifikat Hackathon IMPHNEN"
              >
                {({ ref, open }) => (
                  <img className="hidden"
                    style={smallItemStyles}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <div className="p-5">
                <h5 className="mb-2 text-sm font-semibold tracking-tigh text-center text-white">
                  Festivaloka - Hackathon IMPHNEN x Kolosal AI
                </h5>
                <div className="flex gap-2 mt-3 justify-start">
                  <span className="px-2 py-1 text-xs font-medium text-white bg-blue-600 rounded-full">React</span>
                  <span className="px-2 py-1 text-xs font-medium text-white bg-cyan-500 rounded-full">Tailwind</span>
                </div>
              </div>

            </div>
          </Gallery>

          <Gallery uiElements={uiElements} withCaption>
            <div className="max-w-ws h-full rounded-lg border-b shadow-md bg-gradient-primary border-blue-900 transition-all duration-300 hover:scale-105 hover:shadow-xl cursor-pointer">
              <Item
                original={finflow1}
                thumbnail={finflow1}
                width="1179"
                height="2556"
                caption="Tampilan Dashboard Utama Finflow"
              >
                {({ ref, open }) => (
                  <img className="rounded-t-lg h-48 object-cover w-full"
                    style={{ cursor: 'pointer', objectPosition: 'top' }}
                    src={finflow1}
                    ref={ref}
                    onClick={open}
                  />
                )}
              </Item>

              <Item original={finflow2} thumbnail={finflow2} width="1179" height="2556" caption="Tampilan Daftar Transaksi pada Dashboard">
                {({ ref, open }) => (<img className="hidden" style={smallItemStyles} ref={ref} onClick={open} />)}
              </Item>
              <Item original={finflow3} thumbnail={finflow3} width="1179" height="2556" caption="Tampilan Detail Transaksi (Edit & Hapus)">
                {({ ref, open }) => (<img className="hidden" style={smallItemStyles} ref={ref} onClick={open} />)}
              </Item>
              <Item original={finflow4} thumbnail={finflow4} width="1179" height="2556" caption="Tampilan Form Tambah Transaksi">
                {({ ref, open }) => (<img className="hidden" style={smallItemStyles} ref={ref} onClick={open} />)}
              </Item>
              <Item original={finflow5} thumbnail={finflow5} width="1179" height="2556" caption="Tampilan Pemilihan Kategori Transaksi">
                {({ ref, open }) => (<img className="hidden" style={smallItemStyles} ref={ref} onClick={open} />)}
              </Item>
              <Item original={finflow6} thumbnail={finflow6} width="1179" height="2556" caption="Tampilan Pemilihan Sumber Uang Transaksi">
                {({ ref, open }) => (<img className="hidden" style={smallItemStyles} ref={ref} onClick={open} />)}
              </Item>
              <Item original={finflow7} thumbnail={finflow7} width="1179" height="2556" caption="Tampilan Daftar Pilihan PIC Transaksi">
                {({ ref, open }) => (<img className="hidden" style={smallItemStyles} ref={ref} onClick={open} />)}
              </Item>
              <Item original={finflow8} thumbnail={finflow8} width="1179" height="2556" caption="Tampilan Detail Pemilihan Transaksi">
                {({ ref, open }) => (<img className="hidden" style={smallItemStyles} ref={ref} onClick={open} />)}
              </Item>
              <Item original={finflow9} thumbnail={finflow9} width="1179" height="2556" caption="Tampilan Analisis Keuangan AI (Roasting/Saran Keuangan)">
                {({ ref, open }) => (<img className="hidden" style={smallItemStyles} ref={ref} onClick={open} />)}
              </Item>
              <Item original={finflow10} thumbnail={finflow10} width="1179" height="2556" caption="Tampilan Laporan Statistik Keuangan">
                {({ ref, open }) => (<img className="hidden" style={smallItemStyles} ref={ref} onClick={open} />)}
              </Item>
              <Item original={finflow11} thumbnail={finflow11} width="1179" height="2556" caption="Tampilan Menu Pengaturan Aplikasi">
                {({ ref, open }) => (<img className="hidden" style={smallItemStyles} ref={ref} onClick={open} />)}
              </Item>
              <Item original={finflow12} thumbnail={finflow12} width="1179" height="2556" caption="Tampilan Manajemen Kategori">
                {({ ref, open }) => (<img className="hidden" style={smallItemStyles} ref={ref} onClick={open} />)}
              </Item>
              <Item original={finflow13} thumbnail={finflow13} width="1179" height="2556" caption="Tampilan Form Tambah Kategori Baru">
                {({ ref, open }) => (<img className="hidden" style={smallItemStyles} ref={ref} onClick={open} />)}
              </Item>
              <Item original={finflow14} thumbnail={finflow14} width="1179" height="2556" caption="Tampilan Manajemen Sumber Uang">
                {({ ref, open }) => (<img className="hidden" style={smallItemStyles} ref={ref} onClick={open} />)}
              </Item>
              <Item original={finflow15} thumbnail={finflow15} width="1179" height="2556" caption="Tampilan Manajemen Sumber Uang (Lanjutan)">
                {({ ref, open }) => (<img className="hidden" style={smallItemStyles} ref={ref} onClick={open} />)}
              </Item>
              <Item original={finflow16} thumbnail={finflow16} width="1179" height="2556" caption="Tampilan Form Tambah Sumber Uang Baru">
                {({ ref, open }) => (<img className="hidden" style={smallItemStyles} ref={ref} onClick={open} />)}
              </Item>
              <Item original={finflow17} thumbnail={finflow17} width="1179" height="2556" caption="Tampilan Manajemen Daftar Pengguna (PIC)">
                {({ ref, open }) => (<img className="hidden" style={smallItemStyles} ref={ref} onClick={open} />)}
              </Item>

              <div className="p-5">
                <h5 className="mb-2 text-sm font-semibold tracking-tigh text-center text-white">
                  Finflow (Aplikasi Pencatat Keuangan Pintar)
                </h5>
                <div className="flex gap-2 mt-3 justify-start">
                  <span className="px-2 py-1 text-xs font-medium text-white bg-red-600 rounded-full">Angular</span>
                  <span className="px-2 py-1 text-xs font-medium text-white bg-purple-600 rounded-full">AI Integration</span>
                  <span className="px-2 py-1 text-xs font-medium text-white bg-yellow-600 rounded-full">Google App Script</span>
                  <span className="px-2 py-1 text-xs font-medium text-white bg-green-600 rounded-full">Excel</span>
                </div>
              </div>
            </div>
          </Gallery>

        </div>
      </div>
    </div>
  );
}


export default Portofolio;